module.exports = __webpack_public_path__ + "static/media/bio_age_ven.a210a099.png";